import React from 'react';
import { observer } from 'mobx-react-lite';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useStore } from '../../stores/rootStore';
//import { useStore } from '../../stores/store'; // Ensure this path is correct

/**
 * AdminGuard protects routes by checking both authentication status 
 * and specific staff roles (Admin or Super Admin).
 */
export const AdminGuard = observer((): JSX.Element => {
    const { userStore } = useStore();
    const location = useLocation();

    // 1. Loading State: Prevents premature redirection while Firebase 
    // is checking the existing session on page refresh.
    if (userStore.loading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    // 2. Authorization Logic: Check if the user exists and has staff privileges.
    // 'super-admin' naturally inherits 'admin' permissions here.
    const isStaff = 
        userStore.user?.role === 'admin' || 
        userStore.user?.role === 'super-admin';

    if (!userStore.isLoggedIn || !isStaff) {
        // Redirect unauthorized users to the home page or login.
        // state={{ from: location }} allows for post-login redirect back to the admin area.
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    // 3. Authorized: Render the requested admin child routes.
    return <Outlet />;
});